import { Component, ElementRef, HostListener } from '@angular/core';
import { Store } from '@ngrx/store';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { AnalitycsService } from 'src/app/shared/service/analitycs.service';
import moment from 'moment';
import { Subscription } from 'rxjs';
import { AuthService } from '../../service/auth/auth.service';

@Component({
  selector: 'app-menu-nav',
  templateUrl: './menu-nav.component.html',
  styleUrl: './menu-nav.component.css',
})
export class MenuNavComponent {
  store: any;
  isAuthenticated = false;
  isMobileMenuOpen: boolean = false;
  isDropdownOpen: boolean = false;
  isDarkMode: boolean = false;
  private authSubscription: Subscription | undefined;

  constructor(
    public translate: TranslateService,
    public storeData: Store<any>, //manejar el estado global
    public router: Router,
    private elementRef: ElementRef,
    private analitycs: AnalitycsService,
    private authService: AuthService,
  ) {
    localStorage.setItem('light', 'dark');
    this.storeData
      .select((state) => state.index.theme)
      .subscribe((theme) => {
        this.isDarkMode = theme === 'dark';
      });
    this.initStore();
    // Inicializar el estado de autenticación
    // this.isAuthenticated = this.authService.isAuthenticated();
  }
  async initStore() {
    this.storeData
      .select((d) => d.index)
      .subscribe((d) => {
        this.store = d;
      });
  }

  async ngOnInit() {
    // this.analitycs.logEvent('Initial Header', {
    //   view: 'header',
    //   accion: 'click',
    //   at: moment().format('YYYY-MM-DD HH:mm:ss'),
    // });
    // Suscribirse al estado de autenticación
    this.authSubscription = this.authService.isAuthenticated$.subscribe((status: boolean) => {
      //   console.log('Estado de autenticación cambiado:', status);
      this.isAuthenticated = status;
    });
  }

  //   setActiveDropdown() {
  //     this.analitycs.logEvent('active dropdown menu', {
  //       view: 'header',
  //       accion: 'click',
  //       at: moment().format('YYYY-MM-DD HH:mm:ss'),
  //     });
  //     const selector = document.querySelector('ul.horizontal-menu a[routerLink="' + window.location.pathname + '"]');
  //     if (selector) {
  //       selector.classList.add('active');
  //       const all: any = document.querySelectorAll('ul.horizontal-menu .nav-link.active');
  //       for (let i = 0; i < all.length; i++) {
  //         all[0]?.classList.remove('active');
  //       }
  //       const ul: any = selector.closest('ul.sub-menu');
  //       if (ul) {
  //         let ele: any = ul.closest('li.menu').querySelectorAll('.nav-link');
  //         if (ele) {
  //           ele = ele[0];
  //           setTimeout(() => {
  //             ele?.classList.add('active');
  //           });
  //         }
  //       }
  //     }
  //   }

  toggleDropdown(): void {
    // this.analitycs.logEvent('toggle_menu_navegacion_principal', {
    //   pantalla: 'menu-nav',
    //   accion: 'click',
    //   timestamp: moment().format('YYYY-MM-DD HH:mm:ss'),
    //   plataforma: 'web',
    // });
    this.isDropdownOpen = !this.isDropdownOpen;
  }
  gotoHome() {
    this.analitycs.logEvent('ir_a_inicio_desde_el_header', {
      pantalla: 'menu-nav',
      accion: 'click',
      timestamp: moment().format('YYYY-MM-DD HH:mm:ss'),
      plataforma: 'web',
    });
    this.router.navigate(['/']);
    this.toggleDropdown();
  }
  goToProfile() {
    this.analitycs.logEvent('ir_a_perfil_menu_nav_mobile', {
      pantalla: 'menu-nav',
      accion: 'click',
      timestamp: moment().format('YYYY-MM-DD HH:mm:ss'),
      plataforma: 'web',
    });
    this.router.navigate(['/profile']);
    this.toggleDropdown();
  }
  GoToLogin() {
    this.analitycs.logEvent('ir_a_login_menu_nav_mobile', {
      pantalla: 'menu-nav',
      accion: 'click',
      timestamp: moment().format('YYYY-MM-DD HH:mm:ss'),
      plataforma: 'web',
    });
    this.router.navigate(['/login']);
    this.toggleDropdown();
  }

  toggleMobileMenu() {
    this.isMobileMenuOpen = !this.isMobileMenuOpen;
  }
  goToRegister() {
    this.router.navigate(['/register']);
  }
  goToAssistance() {
    this.analitycs.logEvent('ir_a_asistencia_desde_menu_nav_mobile', {
      pantalla: 'header',
      accion: 'click',
      timestamp: moment().format('YYYY-MM-DD HH:mm:ss'),
      plataforma: 'web',
    });
    this.router.navigate(['/assistant']);
    this.toggleDropdown();
  }
  gotoVehicle() {
    this.router.navigate(['/vehicle']);
    this.toggleDropdown();
  }
  goToCalendar() {
    this.router.navigate(['/calendar']);
    this.toggleDropdown();
  }
  appDownload() {
    this.analitycs.logEvent('descarga_app_menu_nav_mobile', {
      pantalla: 'menu-nav',
      accion: 'click',
      timestamp: moment().format('YYYY-MM-DD HH:mm:ss'),
      plataforma: 'web',
    });
    this.router.navigate(['/app-download']);
  }
  // Detectar clics fuera del dropdown
  @HostListener('document:click', ['$event.target'])
  onClickOutside(targetElement: HTMLElement): void {
    const clickedInside = this.elementRef.nativeElement.contains(targetElement);
    if (!clickedInside) {
      this.isDropdownOpen = false;
      this.isMobileMenuOpen = false;
    }
  }
  goTomanin() {
    this.router.navigate(['/register-main']);
  }
  gotoNotifications() {
    this.analitycs.logEvent('ir_a_notificaciones_desde_menu_nav_mobile', {
      pantalla: 'header',
      accion: 'click',
      timestamp: moment().format('YYYY-MM-DD HH:mm:ss'),
      plataforma: 'web',
    });
    this.router.navigate(['/notifications']);
  }
  gotoCommunity() {
    this.analitycs.logEvent('ir_a_comunidad_desde_menu_nav_mobile', {
      pantalla: 'header',
      accion: 'click',
      timestamp: moment().format('YYYY-MM-DD HH:mm:ss'),
      plataforma: 'web',
    });
    this.router.navigate(['/community']);
  }
  gotoWhatsapp() {
    this.analitycs.logEvent('ir_a_whatsapp_desde_menu_nav_mobile', {
      pantalla: 'header',
      accion: 'click',
      timestamp: moment().format('YYYY-MM-DD HH:mm:ss'),
      plataforma: 'web',
    });
    window.open('https://api.whatsapp.com/send/?phone=573243399281&text&type=phone_number&app_absent=0', '_blank');
  }
}
